import { Component, OnInit } from '@angular/core';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';



@Component({
  selector: 'app-network-status',
  templateUrl: './network-status.component.html',
  styleUrls: ['./network-status.component.scss']
})
export class NetworkStatusComponent implements OnInit {

  LogoutHeader: "classic"|"compact";
  currentDate: string = '';
networkStatuses:any[] = [];
  isLoggedIn: boolean = false;
  // networkStatuses: NetworkStatus[] = [
  //   {
  //     provider: 'Vumatel',
  //     location: 'Little Falls',
  //     badge: 'Update',
  //     time: '1:57 PM, 09 Apr 2026',
  //     message: 'Dear valued client, We are currently experiencing connectivity problems in Little Falls due to a possible network outage on 09 April 2026. Our Provider Vumatel is currently working on resolving the issue. Apologies for the inconvenience caused- Home Connect System'
  //   },
  //   {
  //     provider: 'Zoom Fibre',
  //     location: 'Vanderbijlpark CW 6',
  //     badge: 'Update',
  //     time: '12:02 PM, 09 Apr 2026',
  //     message: 'Dear valued client, We are currently experiencing connectivity problems in Vanderbijlpark CW 6 due to a possible network outage on 09 April 2026. Our Provider Zoom Fibre is currently working on resolving the issue. Apologies for the inconvenience caused-Home Connect System'
  //   },
  //   {
  //     provider: 'Vumatel',
  //     location: 'South Kensington',
  //     badge: 'Update',
  //     time: '11:30 AM, 09 Apr 2026',
  //     message: 'Dear valued client, We are currently experiencing connectivity problems in South Kensington due to a possible network outage on 09 April 2026. Our Provider Vumatel is currently working on resolving the issue. Apologies for the inconvenience caused- Home Connect System'
  //   },
  //   {
  //     provider: 'Zoom Fibre',
  //     location: 'Johannesburg CBD',
  //     badge: 'Resolved',
  //     time: '10:15 AM, 09 Apr 2026',
  //     message: 'Dear valued client, The connectivity issue in Johannesburg CBD has been successfully resolved. Our services are now back to normal. Thank you for your patience- Home Connect System'
  //   },
  //   {
  //     provider: 'Vumatel',
  //     location: 'Pretoria East',
  //     badge: 'Update',
  //     time: '09:45 AM, 09 Apr 2026',
  //     message: 'Dear valued client, We are investigating connectivity issues in Pretoria East. Our technical team is working on it. We apologize for any inconvenience- Home Connect System'
  //   },
  //   {
  //     provider: 'Zoom Fibre',
  //     location: 'Durban North',
  //     badge: 'Resolved',
  //     time: '08:30 AM, 09 Apr 2026',
  //     message: 'Dear valued client, The scheduled maintenance in Durban North has been completed. All systems are operational- Home Connect System'
  //   }
  // ];

  constructor(private lookupservice:LookupDataServiceService) { 
      this.isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  }

  ngOnInit(): void {
    this.setCurrentDate();
    this.getData();
  }
getData() {
  this.lookupservice.getNetworkStatusList().subscribe((res:any)=>{
    this.networkStatuses= res;
  });
}

  setCurrentDate(): void {
    const today = new Date();
    const options: Intl.DateTimeFormatOptions = { month: 'long', year: 'numeric' };
    this.currentDate = today.toLocaleDateString('en-US', options);
  }

}
